import { getDisplayedName as getDisplayedPeopleName } from "@/domain/people/getDisplayedName"
import type {
  PeopleJsonldReadItemPeople,
  SharedDataJsonldReadCollectionSharedData,
  UserJsonldUserReadItem,
} from "@/networking/api"
import { SHARING_PATHS } from "@/routing/paths"
import { isNullOrUndefined } from "@/utils/ts-utils"
import { getDefaultRelatedCluster } from "../cluster/getRelatedCluster"
import { getDefaultUserCollaborator } from "../collaborator/getRelatedUserCollaborator"
import {
  SHARED_DATA_STATUS,
  type SHARED_DATA_STATUS_VALUE,
  SHARED_DATA_TYPE,
  type SHARED_DATA_TYPE_VALUE,
} from "./constants"

export const getSharedSubpath = (shareType?: SHARED_DATA_TYPE_VALUE) => {
  if (shareType === SHARED_DATA_TYPE.PEOPLE) return SHARING_PATHS.PEOPLE
  if (shareType === SHARED_DATA_TYPE.PROJECT) return SHARING_PATHS.PROJECT
  if (shareType === SHARED_DATA_TYPE.INTER_BU) return SHARING_PATHS.INTER_BU
  return ""
}

export const getSharedEntityName = (item: SharedDataJsonldReadCollectionSharedData): string => {
  const type = getSharedEntityType(item)
  if (type === SHARED_DATA_TYPE.PEOPLE)
    return getDisplayedPeopleName(item.people as PeopleJsonldReadItemPeople)
  if (type === SHARED_DATA_TYPE.PROJECT) return item.project?.id ?? "-"
  if (type === SHARED_DATA_TYPE.INTER_BU)
    return getDisplayedPeopleName(item.interBu?.people as PeopleJsonldReadItemPeople)
  return item.id
}

export const getSharedEntityType = (item: SharedDataJsonldReadCollectionSharedData) => {
  if (item?.type?.code === SHARED_DATA_TYPE.PEOPLE) return SHARED_DATA_TYPE.PEOPLE
  if (item?.type?.code === SHARED_DATA_TYPE.PROJECT) return SHARED_DATA_TYPE.PROJECT
  if (item?.type?.code === SHARED_DATA_TYPE.INTER_BU) return SHARED_DATA_TYPE.INTER_BU

  return undefined
}

export const getStatusColor = (status?: string | SHARED_DATA_STATUS_VALUE) => {
  if (status === SHARED_DATA_STATUS.ACCEPTED) return "success"
  if (status === SHARED_DATA_STATUS.DENIED) return "danger"
  if (status === SHARED_DATA_STATUS.REVOKED) return "danger"
  return undefined
}

export const getUserClusterId = (userInfos?: UserJsonldUserReadItem) => {
  if (isNullOrUndefined(userInfos)) return undefined
  const collaborator = getDefaultUserCollaborator(userInfos.collaborators)
  const cluster = getDefaultRelatedCluster(collaborator?.cluster)
  return cluster?.id ?? undefined
}
